import React from 'react';

import TextBox from '@components/TextBox/TextBox';
import { Container, Col, Row } from 'reactstrap';

import MobileListBox from '@components/MobileListBox/MobileListBox';

import Css from './Mobile.scss';

const mobile = (props) => {
  console.log(props);
    return (
        <React.Fragment>
            <Container fluid={true} style={{height: '400px'}}>
                <Row className={'justify-content-center  align-items-center h-100'}>
                    <Col xs={11}>
                        <TextBox header={'Compare Aircraft'} style={{paddingBottom: '0.1rem'}} isHeader={true}/>
                    </Col>
                </Row>
            </Container>

            <div className={Css["list-box"] + ' w-100'}>
                {props.boxs.map( (box) =>
                    <MobileListBox key={box.id} activeBoxId={props.mobileActive} box={box} click={() => props.click(box.id)} />
                )}
            </div>
        </React.Fragment>
    );
}

export default mobile;


// WEBPACK FOOTER //
// ./src/components/CompareAircraft/Mobile/Mobile.js